import axios from 'axios';

// const ip = process.env.VUE_APP_ELASTIC_API;

const API_URL = process.env.VUE_APP_BASE_API_URL_OSINT;

class InstaService {
    search(data) {
        return axios.post(API_URL+'instagram/user_info', data);
    }
    getUsername(data) {
        return axios.post(API_URL+'instagram/get_profile', data);
    }


    getRecentPost(data) {
        
    }

    getHeatMap(data) {
        return axios.post(API_URL+'instagram/heatmap', data);
    }
    getHeatMapElastic(ip, username){
        return axios.get(ip+'osint_instagram_heatmap/_doc/'+username,  { headers: {'Content-Type': 'application/json'}});
    }
    createHeatMapElastic(ip, username, data){
        return axios.put(ip+'osint_instagram_heatmap/_doc/'+username, data, { headers: {'Content-Type': 'application/json'}});
    }
    

    getTimelineIG(data){
        return axios.post(API_URL+'instagram/get-timeline', data);
    }
    getTimelineElastic(ip, username){
        return axios.get(ip+'osint_instagram_timeline/_doc/'+username,  { headers: {'Content-Type': 'application/json'}});
    }
    createTimelineElastic(ip, username, data){
        return axios.put(ip+'osint_instagram_timeline/_doc/'+username, data, { headers: {'Content-Type': 'application/json'}});
    }


    getUserTagsIG(data){
        return axios.post(API_URL+'instagram/get-usertags', data);
    }
    getUserTagsElastic(ip, username){
        return axios.get(ip+'osint_instagram_usertag/_doc/'+username,  { headers: {'Content-Type': 'application/json'}});
    }
    createUsertagElastic(ip, username, data){
        return axios.put(ip+'osint_instagram_usertag/_doc/'+username, data, { headers: {'Content-Type': 'application/json'}});
    }


    
    getWordCloud(data) {
        return axios.post(API_URL+'instagram/IGword-cloud', data);
    }
    
    getWordcloudElastic(ip, username){
        return axios.get(ip+'osint_instagram_wordcloud/_doc/'+username,  { headers: {'Content-Type': 'application/json'}});
    }
    createWordCloudElastic(ip, username, data){
        return axios.put(ip+'osint_instagram_wordcloud/_doc/'+username, data, { headers: {'Content-Type': 'application/json'}});
    }


    SentimentAnalys(data) {
        return axios.post(API_URL+'instagram/IGsentiment-analys', data);
    }
    getSentimentElastic(ip, username){
        return axios.get(ip+'osint_instagram_sentiment/_doc/'+username,  { headers: {'Content-Type': 'application/json'}});
    }
    createSentimentElastic(ip, username, data){
        return axios.put(ip+'osint_instagram_sentiment/_doc/'+username, data, { headers: {'Content-Type': 'application/json'}});
    }

    
    Followers(data) {
        return axios.post(API_URL+'instagram/get-followers', data);
    }
    getFollowersElastic(ip, username){
        return axios.get(ip+'osint_instagram_followers/_doc/'+username,  { headers: {'Content-Type': 'application/json'}});
    }
    createFollowersElastic(ip, username, data){
        return axios.put(ip+'osint_instagram_followers/_doc/'+username, data, { headers: {'Content-Type': 'application/json'}});
    }

    getLastFollowing(data) {
        return axios.post(API_URL+'instagram/get-following', data);
    }

        
    Following(data) {
        return axios.post(API_URL+'instagram/get-following', data);
    }
    getFollowingElastic(ip, username){
        return axios.get(ip+'osint_instagram_following/_doc/'+username,  { headers: {'Content-Type': 'application/json'}});
    }
    createFollowingElastic(ip, username, data){
        return axios.put(ip+'osint_instagram_following/_doc/'+username, data, { headers: {'Content-Type': 'application/json'}});
    }

    getLastFollowing(data) {
        return axios.post(API_URL+'instagram/get-following', data);
    }

    getSimiliarElastic(ip, username){
        return axios.get(ip+'osint_instagram_similiar/_doc/'+username,  { headers: {'Content-Type': 'application/json'}});
    }
    createSimiliarElastic(ip, username, data){
        return axios.put(ip+'osint_instagram_similiar/_doc/'+username, data, { headers: {'Content-Type': 'application/json'}});
    }




   
    getMedia(data) {
        return axios.post(API_URL+'instagram/IGdownload_media', data);
    }
    
    listMedia(data) {
        return axios.post(API_URL+'instagram/list-media', data);
    }
}

export default new InstaService();
